<template>
  <div>
    <!-- <v-card outlined style="border-radius:20px;" class="py-1 px-5" min-height="100%">  -->
      <!-- <div class="success--text overline "><v-icon size="16" color="success">mdi-database-check-outline</v-icon> SALDO DISPONIVEL</div> -->
      <!-- <div class="headline mt-0 font-weight-black">R$ 20.000,00</div> -->

      <default-financial-card :background_color="background_color" :value="data" :title="title" :icon="icon" :title_class="title_class" :icon_color="icon_color">
        <template v-slot:extra>
          Integralizado
          <!-- <v-tooltip bottom color='black'>
            <template v-slot:activator="{on}">
              <div v-on="on" class="subtitle-2" style="position: absolute; top: 60px; right: 15px;">E - S - ER + RR</div>
            </template>
            <div class="subtitle-2" style="text-align: right;">Entradas - Saídas - Entradas Reserva + Retirada Reserva</div>
          </v-tooltip> -->

        </template>
      </default-financial-card>

    <!-- </v-card> -->
  </div>
</template>

<script>
  export default {
    name: 'BalanceAvaliable',

    components: {
      DefaultFinancialCard: () => import ('./DefaultFinancialCard.vue'),
    },

    props: {
      data: {
        type: Number,
      },
    },

    data() {
      return {
        // value: 15000,
        title: 'Saldo',
        icon: 'mdi-cash-check',
        title_class: 'success--text overline',
        icon_color: 'primary',
        background_color: 'rgba(63,167,255,0.3)'
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>